import { apiGateway } from "@/_old/services/api-gateway";
import { getRefreshToken } from "./cookies";
import { MeResponse } from "../types";

export const refreshToken = async () => {
  const refreshToken = getRefreshToken();

  if (!refreshToken) {
    throw new Error("No refresh token found");
  }

  const response = await apiGateway.post<{
    token: string;
    refreshToken: string;
  }>("/auth/refresh-token", {
    refreshToken: refreshToken,
  });

  return response.data;
};

export const getMe = async () => {
  const response = await apiGateway.get<MeResponse>(
    "/api/v1/users/me?fl=profile,plan,spaces,league",
  );
  return response.data;
};
